<template>
  <div>
    <v-btn
      small
      class="ml-3"
      @click="dialog = true"
      >
      filtros
    </v-btn>

    <SysDialog
      v-model="dialog"
      titulo="Filtros"
      txtBotao="Filtrar"
      @click:primary="atualizar($event)"
    >
      <SysSegmentoAutocomplete
        v-model="FILTROS.idfamilia_produto"
        outlined
        multiple
        label="Selecione o segmentos"
        class="mb-5"
      />

      <SysCompradorAutocomplete
        v-model="FILTROS.idcomprador"
        outlined
        multiple
        :ids-segmento="FILTROS.idfamilia_produto"
        label="Selecione o comprador"
      />
    </SysDialog>
  </div>
</template>

<script>
import SysDialog from '@/components/padraoDeLayout/SysDialog.vue';
import SysCompradorAutocomplete from '@/components/utils/crud/SysCompradorAutocomplete.vue';
import SysSegmentoAutocomplete from '@/components/utils/crud/SysSegmentoAutocomplete.vue';

export default {
  components: {
    SysDialog,
    SysSegmentoAutocomplete,
    SysCompradorAutocomplete
  },
  props: {
    filtros: {
      type: Object,
      required: true
    },
  },
  data() {
    return {
      dialog: false,
      selected: []
    }
  },
  computed: {
    FILTROS: {
      get() { return this.filtros },
      set(value) { this.$emit('atualizar-filtros', value) }
    }
  },
  methods: {
    atualizar(evento) {
      this.$emit('atualizar-tela-deparametrizacao-fornecedor');
      this.dialog = false;
    }
  }
}
</script>

<style>

</style>
